import { cn } from "@/lib/cn";
import type { DeliveryProgress } from "@/api";

export function DeliveryProgressBar({
  progress,
  className,
}: {
  progress: DeliveryProgress | null | undefined;
  className?: string;
}) {
  if (!progress || progress.total <= 0) return null;
  const { submitted, total, unknown, failed, queued } = progress;
  const bounced = progress.bounced ?? 0;
  const parts = [
    { key: "submitted", n: submitted, className: "bg-green" },
    { key: "queued", n: queued, className: "bg-accent" },
    { key: "failed", n: failed, className: "bg-danger" },
    { key: "unknown", n: unknown, className: "bg-amber" },
  ].filter((part) => part.n > 0);

  return (
    <div className={cn("min-w-[8rem]", className)}>
      <div className="flex items-baseline justify-between gap-2 text-[11px] text-muted">
        <span className="tabular-nums">
          {submitted} von {total} zugestellt
        </span>
        {unknown > 0 ? (
          <span className="text-danger tabular-nums">{unknown} unbekannt</span>
        ) : failed > 0 ? (
          <span className="text-danger tabular-nums">{failed} fehlgeschlagen</span>
        ) : bounced > 0 ? (
          <span className="text-amber tabular-nums">{bounced} zurückgekommen</span>
        ) : null}
      </div>
      <div className="mt-1 flex h-1.5 overflow-hidden rounded-full bg-surface-subtle">
        {parts.map((part) => (
          <span
            key={part.key}
            className={cn("h-full", part.className)}
            style={{ width: `${(part.n / total) * 100}%` }}
          />
        ))}
      </div>
    </div>
  );
}
